import {
    ComponentsOverrides,
    ComponentsProps,
    ComponentsVariants,
    Theme,
} from '@mui/material';

interface M3Icon {
    MuiIcon: {
        defaultProps?: ComponentsProps['MuiIcon'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiIcon'];
        variants?: ComponentsVariants['MuiIcon'];
    };
}

const rtlFlipIcons = ['edit_square'];

export const getIcon = (theme: Theme): M3Icon => {
    return {
        MuiIcon: {
            defaultProps: {
                baseClassName: 'material-symbols-outlined',
            },
            styleOverrides: {
                root: props => {
                    if (document.documentElement.dir === 'rtl') {
                        if (rtlFlipIcons.includes(props.children)) {
                            return {
                                transform: 'scaleX(-1)',
                            };
                        }
                    }
                    return {};
                },
            },
        },
    };
};
